module.exports = __webpack_public_path__ + "img/Hand-held article tracking behavior determination method.8aecc08d.png";